module.exports = __webpack_public_path__ + "static/media/ticket_campaign_preview_name_pic.2205c4e7.svg";